var spoiler_default = {
  "fontElementMap": "c7-7q",
  "hideText": "gCKiS",
  "onHoverText": "JNkWO",
  "hideBlock": "-wqwu",
  "smallBlur": "Rqa8L",
  "mediumBlur": "Cv0pw",
  "largeBlur": "UnDdR",
  "hideBlock_gallery": "pl6jw",
  "overlay": "Q3xJY",
  "overlay_gallery": "SdLyP",
  "revealSpoilerBtn": "PGL9A",
  "isMobile": "YUtoc",
  "onHoverBtn": "oiE0L",
  "spoilerWrapper": "YfAoF",
  "spoilerDescription": "_5HjdL",
  "spoilerContainer": "GoPJb",
  "spoilerContainer_Gallery": "_-2jje"
};
export {
  spoiler_default as default
};
//# sourceMappingURL=spoiler-scss.js.map
